var $75ZOZ$swchelperscjs_class_call_checkcjs = require("@swc/helpers/cjs/_class_call_check.cjs");
var $75ZOZ$swchelperscjs_create_classcjs = require("@swc/helpers/cjs/_create_class.cjs");
var $75ZOZ$swchelperscjs_object_spreadcjs = require("@swc/helpers/cjs/_object_spread.cjs");
var $75ZOZ$analytics = require("analytics");
var $75ZOZ$analyticsgoogleanalytics = require("@analytics/google-analytics");
var $75ZOZ$jscookie = require("js-cookie");
var $75ZOZ$ajv = require("ajv");
var $75ZOZ$swchelperscjs_object_without_propertiescjs = require("@swc/helpers/cjs/_object_without_properties.cjs");


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
$parcel$export(module.exports, "viewItem", function () { return $8911f1b03957d3bd$export$e49cfcc742d815aa; });
$parcel$export(module.exports, "pageView", function () { return $4a5e26ab6e6f9fde$export$8d2435c39cb64436; });
var $164744549ff29b1c$exports = {};
$164744549ff29b1c$exports = JSON.parse('{"name":"@JohnLewisPartnership/jl-interaction-events","publishConfig":{"@JohnLewisPartnership:registry":"https://gitlab.com/api/v4/projects/51271009/packages/npm/"},"version":"0.0.7","description":"An analytics events abstraction library (PoC)","source":"src/index.js","main":"dist/main.js","browserslist":["cover 99.5%"],"scripts":{"watch":"parcel watch","build":"parcel build","test":"echo \\"Error: no test specified\\" && exit 1"},"author":"","license":"ISC","devDependencies":{"parcel":"^2.10.0","prettier":"^3.0.3"},"dependencies":{"@swc/helpers":"^0.5.11","@analytics/google-analytics":"^1.0.7","ajv":"^8.12.0","analytics":"^0.8.9","comlink":"^4.4.1","js-cookie":"^3.0.5"}}');








var $677a336415a1cfca$export$1dde1db9e656bcd0 = function(text) {
    if (typeof text !== "string") return text;
    var piiRegEx = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)|(name|&e|mail|phone|mobile|tel|contactnumber|contact|password|postalcode|postcode|zipcode|zip)(=)([^&]*)/gim;
    return decodeURIComponent(text).replace(piiRegEx, "$2$3[REDACTED]");
};



var $eba0e9cc0a78dfbd$export$25c3b5e872622abd = function() {
    var _Cookies_get;
    var gaStrings = (_Cookies_get = (0, ($parcel$interopDefault($75ZOZ$jscookie))).get("_ga")) === null || _Cookies_get === void 0 ? void 0 : _Cookies_get.split(".");
    return gaStrings ? "".concat(gaStrings[2], ".").concat(gaStrings[3]) : "";
};
var $eba0e9cc0a78dfbd$export$78aeec38f1fe430d = function() {
    var _global_window_ga4Data, _global_window, _global;
    var storedPrevPageName = (0, ($parcel$interopDefault($75ZOZ$jscookie))).get("gpv_pn");
    return storedPrevPageName ? storedPrevPageName : ((_global = $parcel$global) === null || _global === void 0 ? void 0 : (_global_window = _global.window) === null || _global_window === void 0 ? void 0 : (_global_window_ga4Data = _global_window.ga4Data) === null || _global_window_ga4Data === void 0 ? void 0 : _global_window_ga4Data.previous_page_name) || "";
};
var $eba0e9cc0a78dfbd$export$36781d48dfd43de4 = function() {
    var analyticsConsent = (0, ($parcel$interopDefault($75ZOZ$jscookie))).get("JOHNLEWIS_ENSIGHTEN_PRIVACY_Analytics") || "0";
    var advertisingConsent = (0, ($parcel$interopDefault($75ZOZ$jscookie))).get("JOHNLEWIS_ENSIGHTEN_PRIVACY_Advertising") || "0";
    var consentType = (0, ($parcel$interopDefault($75ZOZ$jscookie))).get("JOHNLEWIS_ENSIGHTEN_PRIVACY_BANNER_VIEWED") !== "1" ? "default" : "update";
    return "G1" + advertisingConsent + analyticsConsent + " - " + consentType;
};
var $eba0e9cc0a78dfbd$export$cd0397a379f42b71 = function() {
    return (0, ($parcel$interopDefault($75ZOZ$jscookie))).get("shopperId") || "";
};
var $eba0e9cc0a78dfbd$export$e9fbecca773117a5 = function() {
    return (0, ($parcel$interopDefault($75ZOZ$jscookie))).get("mt.v") || "";
};
var $eba0e9cc0a78dfbd$export$b10d880ac0c6dec1 = function() {
    return (0, ($parcel$interopDefault($75ZOZ$jscookie))).get("_cs_id") || "";
};
var $eba0e9cc0a78dfbd$export$79408d92cf378f9e = function() {
    var findingMethod = (0, ($parcel$interopDefault($75ZOZ$jscookie))).get("ensFindingMethod");
    return findingMethod ? JSON.parse(findingMethod) : "";
};
var $eba0e9cc0a78dfbd$export$e654277c48f6e4df = function() {
    (0, ($parcel$interopDefault($75ZOZ$jscookie))).get("ensRRCookie").replace("|eVar99=", "");
};


var $e89b7fa61e672dc8$var$getPageProp = function(key) {
    var _window_jlData_page_pageInfo, _window_jlData_page, _window_jlData, _window;
    var pageProp = (_window = window) === null || _window === void 0 ? void 0 : (_window_jlData = _window.jlData) === null || _window_jlData === void 0 ? void 0 : (_window_jlData_page = _window_jlData.page) === null || _window_jlData_page === void 0 ? void 0 : (_window_jlData_page_pageInfo = _window_jlData_page.pageInfo) === null || _window_jlData_page_pageInfo === void 0 ? void 0 : _window_jlData_page_pageInfo[key];
    return pageProp || "";
};
var $e89b7fa61e672dc8$var$getScreenSize = function() {
    return window.innerWidth + "x" + window.innerHeight;
};
var $e89b7fa61e672dc8$var$getUrlQs = function() {
    var urls = document.location.href.split(document.location.pathname);
    return (0, $677a336415a1cfca$export$1dde1db9e656bcd0)(urls[urls.length - 1]);
};
var $e89b7fa61e672dc8$var$getUrlWoQus = function() {
    return "".concat(document.location.origin).concat(document.location.pathname);
};
var $e89b7fa61e672dc8$var$getBreadcrumbs = function() {
    var _breadcrumbs_map;
    var breadcrumbs = $e89b7fa61e672dc8$var$getPageProp("breadCrumb");
    if (!Array.isArray(breadcrumbs)) return "";
    return (_breadcrumbs_map = breadcrumbs.map(function(param) {
        var value = param.value;
        return value.toLowerCase();
    })) === null || _breadcrumbs_map === void 0 ? void 0 : _breadcrumbs_map.join(">");
};
var $e89b7fa61e672dc8$var$getEnsightenSpace = function() {
    var _window;
    if (!window.Bootstrapper) return "";
    return (_window = window) === null || _window === void 0 ? void 0 : _window.Bootstrapper.ensightenOptions.publishPath.toLowerCase();
};
var $e89b7fa61e672dc8$var$isWeekend = function() {
    var today = new Date();
    var dayOfWeek = today.getDay();
    return dayOfWeek === 0 || dayOfWeek === 6;
};
var $e89b7fa61e672dc8$var$getUserId = function() {
    var _window_jlData_customer_customerInfo, _window_jlData_customer, _window_jlData, _window;
    var userId = (_window = window) === null || _window === void 0 ? void 0 : (_window_jlData = _window.jlData) === null || _window_jlData === void 0 ? void 0 : (_window_jlData_customer = _window_jlData.customer) === null || _window_jlData_customer === void 0 ? void 0 : (_window_jlData_customer_customerInfo = _window_jlData_customer.customerInfo) === null || _window_jlData_customer_customerInfo === void 0 ? void 0 : _window_jlData_customer_customerInfo.signinId;
    var storedShopperId = (0, $eba0e9cc0a78dfbd$export$cd0397a379f42b71)();
    return userId ? userId : storedShopperId;
};
var $e89b7fa61e672dc8$var$getUserProperties = function() {
    return (0, $75ZOZ$swchelperscjs_object_spreadcjs._)({}, (0, $eba0e9cc0a78dfbd$export$cd0397a379f42b71)() && {
        signin_id: (0, $eba0e9cc0a78dfbd$export$cd0397a379f42b71)()
    }, (0, $eba0e9cc0a78dfbd$export$e9fbecca773117a5)() && {
        monetate_id: (0, $eba0e9cc0a78dfbd$export$e9fbecca773117a5)()
    }, (0, $eba0e9cc0a78dfbd$export$b10d880ac0c6dec1)() && {
        cs_id: (0, $eba0e9cc0a78dfbd$export$b10d880ac0c6dec1)()
    });
};
var $e89b7fa61e672dc8$var$getProductPageProp = function(key) {
    var _window_jlData_page_productPages, _window_jlData_page, _window_jlData, _window;
    var prop = (_window = window) === null || _window === void 0 ? void 0 : (_window_jlData = _window.jlData) === null || _window_jlData === void 0 ? void 0 : (_window_jlData_page = _window_jlData.page) === null || _window_jlData_page === void 0 ? void 0 : (_window_jlData_page_productPages = _window_jlData_page.productPages) === null || _window_jlData_page_productPages === void 0 ? void 0 : _window_jlData_page_productPages[key];
    return prop || undefined;
};
var $e89b7fa61e672dc8$var$getProductPagePrice = function() {
    var price = $e89b7fa61e672dc8$var$getProductPageProp("price");
    return price ? parseFloat(price) : 0;
};
var $e89b7fa61e672dc8$var$getProductPageViewType = function() {
    var productViewType = $e89b7fa61e672dc8$var$getProductPageProp("productViewType");
    return productViewType ? productViewType.toLowerCase() : "";
};
var $e89b7fa61e672dc8$var$getProductPagePromotion = function() {
    var promotion = $e89b7fa61e672dc8$var$getProductPageProp("promotions");
    return promotion ? promotion.split("|")[0].trim().toLowerCase() : "no promotion";
};
var $e89b7fa61e672dc8$var$getViewItemFindingMethod = function() {
    var _getPageProp, _window_ens_dataStateChangeEventInfoGA, _window;
    var pageType = $e89b7fa61e672dc8$var$getPageProp("pageType");
    var recsSource = (_getPageProp = $e89b7fa61e672dc8$var$getPageProp("quickView")) === null || _getPageProp === void 0 ? void 0 : _getPageProp.source;
    var ensCustomEvent = (_window = window) === null || _window === void 0 ? void 0 : (_window_ens_dataStateChangeEventInfoGA = _window.ens_dataStateChangeEventInfoGA) === null || _window_ens_dataStateChangeEventInfoGA === void 0 ? void 0 : _window_ens_dataStateChangeEventInfoGA.detail;
    if (ensCustomEvent === "rvi") return "recently viewed";
    if (recsSource) return "Recommendation Service - " + recsSource;
    switch(pageType){
        case "search results":
            return "search";
        case "product list page grid":
            return "browse";
        case "xmas virtual experience":
            return "xmas virtual experience";
        default:
            return "browse";
    }
};
var $e89b7fa61e672dc8$var$getProductColour = function() {
    var colour = $e89b7fa61e672dc8$var$getProductPageProp("colour");
    return colour ? colour.toLowerCase() : "";
};
var $e89b7fa61e672dc8$var$getProductSize = function() {
    var size = $e89b7fa61e672dc8$var$getProductPageProp("size");
    return size ? size.toLowerCase() : "";
};
var $e89b7fa61e672dc8$var$getRecsPlacement = function() {
    var ensFindingMethod = (0, $eba0e9cc0a78dfbd$export$79408d92cf378f9e)();
    var productId = $e89b7fa61e672dc8$var$getProductPageProp("productId");
    if (!ensFindingMethod || !productId) return "";
    if (ensFindingMethod.method === "recommendation" && ensFindingMethod.productId === productId) return (0, $eba0e9cc0a78dfbd$export$e654277c48f6e4df)();
};
var $e89b7fa61e672dc8$var$getProductItems = function() {
    var _window_jlData_page, _window_jlData, _window, _window_jlData_page1, _window_jlData1, _window1, _pageInfo_breadCrumb;
    var productPages = (_window = window) === null || _window === void 0 ? void 0 : (_window_jlData = _window.jlData) === null || _window_jlData === void 0 ? void 0 : (_window_jlData_page = _window_jlData.page) === null || _window_jlData_page === void 0 ? void 0 : _window_jlData_page.productPages;
    var pageInfo = (_window1 = window) === null || _window1 === void 0 ? void 0 : (_window_jlData1 = _window1.jlData) === null || _window_jlData1 === void 0 ? void 0 : (_window_jlData_page1 = _window_jlData1.page) === null || _window_jlData_page1 === void 0 ? void 0 : _window_jlData_page1.pageInfo;
    var prodCats = [];
    if ((pageInfo === null || pageInfo === void 0 ? void 0 : (_pageInfo_breadCrumb = pageInfo.breadCrumb) === null || _pageInfo_breadCrumb === void 0 ? void 0 : _pageInfo_breadCrumb.length) > 0) prodCats = pageInfo.breadCrumb.filter(function(cr) {
        return cr.clickable;
    }).map(function(cr) {
        return cr.value;
    });
    if (productPages) return [
        {
            item_id: productPages.productId || "",
            item_name: productPages.productName || "",
            item_brand: productPages.brand || "",
            item_category: prodCats[0] ? prodCats[0] : "",
            item_category2: prodCats[1] ? prodCats[1] : "",
            item_category3: prodCats[2] ? prodCats[2] : "",
            item_category4: prodCats[3] ? prodCats[3] : "",
            item_category5: prodCats[4] ? prodCats[4] : "",
            item_list_id: "",
            item_list_name: "",
            price: productPages.price,
            quantity: 1,
            location_id: $e89b7fa61e672dc8$var$getViewItemFindingMethod(),
            promotion: $e89b7fa61e672dc8$var$getProductPagePromotion(),
            finding_method: $e89b7fa61e672dc8$var$getViewItemFindingMethod(),
            product_view_type: $e89b7fa61e672dc8$var$getProductPageViewType(),
            item_color: $e89b7fa61e672dc8$var$getProductColour(),
            item_size: $e89b7fa61e672dc8$var$getProductSize(),
            recs_placement: $e89b7fa61e672dc8$var$getRecsPlacement()
        }
    ];
    return [];
};
var $e89b7fa61e672dc8$export$926b98dca63bd07a = function() {
    var _getPageProp_, _getPageProp;
    if (typeof window === "undefined" || typeof document === "undefined") return {};
    return {
        app_id: "jlwebdev",
        page_title: $e89b7fa61e672dc8$var$getPageProp("pageName"),
        page_name: $e89b7fa61e672dc8$var$getPageProp("pageName"),
        page_type: $e89b7fa61e672dc8$var$getPageProp("pageType"),
        page_location: document.location.href,
        site_section: ((_getPageProp = $e89b7fa61e672dc8$var$getPageProp("breadCrumb")) === null || _getPageProp === void 0 ? void 0 : (_getPageProp_ = _getPageProp[0]) === null || _getPageProp_ === void 0 ? void 0 : _getPageProp_.value) || "",
        page_referrer: (0, $677a336415a1cfca$export$1dde1db9e656bcd0)(document.referrer),
        previous_page_name: (0, $eba0e9cc0a78dfbd$export$78aeec38f1fe430d)(),
        ga_client_id: (0, $eba0e9cc0a78dfbd$export$25c3b5e872622abd)(),
        screen_size: $e89b7fa61e672dc8$var$getScreenSize(),
        page_url_qs: $e89b7fa61e672dc8$var$getUrlQs(),
        page_url_wo_qs: $e89b7fa61e672dc8$var$getUrlWoQus(),
        page_breadcrumb: $e89b7fa61e672dc8$var$getBreadcrumbs(),
        domain: document.location.hostname,
        ensighten_space: $e89b7fa61e672dc8$var$getEnsightenSpace(),
        page_path: (0, $677a336415a1cfca$export$1dde1db9e656bcd0)(window.location.pathname),
        content_group: $e89b7fa61e672dc8$var$getPageProp("pageType"),
        isWeekend: $e89b7fa61e672dc8$var$isWeekend().toString(),
        consent_mode: (0, $eba0e9cc0a78dfbd$export$36781d48dfd43de4)(),
        user_id: $e89b7fa61e672dc8$var$getUserId(),
        user_properties: $e89b7fa61e672dc8$var$getUserProperties(),
        page_config_name: ""
    };
};
var $e89b7fa61e672dc8$export$4f6f717d2b9d454d = function() {
    if (typeof window === "undefined" || typeof document === "undefined") return {};
    return {
        value: $e89b7fa61e672dc8$var$getProductPagePrice(),
        currency: "GBP",
        product_view_type: $e89b7fa61e672dc8$var$getProductPageViewType(),
        promotion: $e89b7fa61e672dc8$var$getProductPagePromotion(),
        finding_method: $e89b7fa61e672dc8$var$getViewItemFindingMethod(),
        item_color: $e89b7fa61e672dc8$var$getProductColour(),
        size: $e89b7fa61e672dc8$var$getProductSize(),
        items: $e89b7fa61e672dc8$var$getProductItems(),
        recs_placement: $e89b7fa61e672dc8$var$getRecsPlacement(),
        available_skus: $e89b7fa61e672dc8$var$getProductPageProp("numberOfAvailableProductSkus") || "",
        total_skus: $e89b7fa61e672dc8$var$getProductPageProp("numberOfProductSkus") || ""
    };
};


var $25dc082de19b525f$var$AnalyticsCore = /*#__PURE__*/ function() {
    "use strict";
    function AnalyticsCore() {
        (0, $75ZOZ$swchelperscjs_class_call_checkcjs._)(this, AnalyticsCore);
        this.analytics = (0, $75ZOZ$analytics.Analytics)({
            app: "jlwebdev",
            plugins: [
                (0, ($parcel$interopDefault($75ZOZ$analyticsgoogleanalytics)))({
                    measurementIds: [
                        "G-S79QY0WLMB"
                    ],
                    dataLayerName: "jlInteractionEvents",
                    gtagName: "jlInteractionsGtag",
                    debug: true,
                    send_page_view: false,
                    gtagConfig: (0, $75ZOZ$swchelperscjs_object_spreadcjs._)({}, (0, $e89b7fa61e672dc8$export$926b98dca63bd07a)())
                })
            ]
        });
    }
    (0, $75ZOZ$swchelperscjs_create_classcjs._)(AnalyticsCore, [
        {
            key: "track",
            value: function track(eventName, data) {
                this.analytics.track(eventName, data);
            }
        }
    ]);
    return AnalyticsCore;
}();
var $25dc082de19b525f$export$2e2bcd8739ae039 = new $25dc082de19b525f$var$AnalyticsCore();



var $af6d29b90d45b380$export$be8a07fe7670f466 = new (0, ($parcel$interopDefault($75ZOZ$ajv)))();
var $af6d29b90d45b380$export$a22775fa5e2eebd9 = function(schema) {
    return function(data) {
        var validateSchema = $af6d29b90d45b380$export$be8a07fe7670f466.compile(schema);
        var isValid = validateSchema(data);
        return {
            isValid: isValid,
            errors: validateSchema.errors
        };
    };
};
var $af6d29b90d45b380$export$e0567ecb54a9a23c = function(errors, eventName) {
    console.error("Schema validation failed for event: ".concat(eventName, " (").concat(errors[0].message, ")"));
};
var $af6d29b90d45b380$export$612a8130919eb8f3 = function(payload, schema) {};


var $fdb517a2a7c23c49$exports = {};
$fdb517a2a7c23c49$exports = JSON.parse('{"type":"object","title":"page_view event schema","description":"This schema is used for all page view events","properties":{"page_name":{"type":"string"},"page_title":{"type":"string"},"page_location":{"type":"string"},"payment_applepay_available":{"type":"string"},"navigation_type":{"type":"string"},"delivery_method_id":{"type":"string"}},"additionalProperties":false}');


var $4a5e26ab6e6f9fde$export$8d2435c39cb64436 = function() {
    var payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var schema = (0, $af6d29b90d45b380$export$a22775fa5e2eebd9)((0, (/*@__PURE__*/$parcel$interopDefault($fdb517a2a7c23c49$exports))))(payload);
    console.log(schema.isValid);
    if (!schema.isValid) (0, $af6d29b90d45b380$export$e0567ecb54a9a23c)(schema.errors, "page_view");
    else (0, $25dc082de19b525f$export$2e2bcd8739ae039).track("page_view", payload);
};






var $89a26e586bc5367e$exports = {};
$89a26e586bc5367e$exports = JSON.parse('{"title":"view_item event schema","description":"This schema is used for view_item events on PDP","type":"object","properties":{"available_skus":{"type":"string"},"currency":{"type":"string"},"finding_method":{"type":"string"},"item_color":{"type":"string"},"item_size":{"type":"string"},"items":{"type":"array","items":{"type":"object","properties":{"finding_method":{"type":"string"},"item_brand":{"type":"string"},"item_category":{"type":"string"},"item_category2":{"type":"string"},"item_category3":{"type":"string"},"item_category4":{"type":"string"},"item_category5":{"type":"string"},"item_color":{"type":"string"},"item_id":{"type":"string"},"item_list_id":{"type":"string"},"item_list_name":{"type":"string"},"item_name":{"type":"string"},"item_size":{"type":"string"},"location_id":{"type":"string"},"price":{"type":"string"},"product_view_type":{"type":"string"},"promotion":{"type":"string"},"quantity":{"type":"integer"},"recs_placement":{"type":"string"}},"required":["item_brand","item_category","item_color","item_id","item_name","item_size","price","product_view_type","promotion","quantity"]}},"product_view_type":{"type":"string"},"promotion":{"type":"string"},"recs_placement":{"type":"string"},"total_skus":{"type":"string"},"value":{"type":"number"}},"required":[]}');



var $8911f1b03957d3bd$export$e49cfcc742d815aa = function() {
    var payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var schema = (0, $af6d29b90d45b380$export$a22775fa5e2eebd9)((0, (/*@__PURE__*/$parcel$interopDefault($89a26e586bc5367e$exports))))(payload);
    console.log(schema.isValid);
    if (!schema.isValid) (0, $af6d29b90d45b380$export$e0567ecb54a9a23c)(schema.errors, "view_item");
    else {
        var sendTo = payload.sendTo, send_to = payload.send_to, rest = (0, $75ZOZ$swchelperscjs_object_without_propertiescjs._)(payload, [
            "sendTo",
            "send_to"
        ]); // extract send_to out of the payload
        (0, $25dc082de19b525f$export$2e2bcd8739ae039).track("view_item", (0, $75ZOZ$swchelperscjs_object_spreadcjs._)({}, (0, $e89b7fa61e672dc8$export$4f6f717d2b9d454d)(), rest));
    }
};




console.info("[JLIE] v".concat((0, (/*@__PURE__*/$parcel$interopDefault($164744549ff29b1c$exports))).version));


//# sourceMappingURL=main.js.map
